/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SafeLocation = {
    Basel: 'BASEL',
    Bern: 'BERN',
    CransMontana: 'CRANS_MONTANA',
    GenfRueFatio: 'GENF_RUE_FATIO',
    GenfRueDeLaFleche: 'GENF_RUE_DE_LA_FLECHE',
    Lausanne: 'LAUSANNE',
    Lugano: 'LUGANO',
    Luzern: 'LUZERN',
    Sion: 'SION',
    StMoritz: 'ST_MORITZ',
    StGallen: 'ST_GALLEN',
    Verbier: 'VERBIER',
    ZuerichBahnhofstrasse: 'ZUERICH_BAHNHOFSTRASSE',
    ZuerichMorgartenstrasse: 'ZUERICH_MORGARTENSTRASSE'
} as const;
export type SafeLocation = typeof SafeLocation[keyof typeof SafeLocation];


export function instanceOfSafeLocation(value: any): boolean {
    for (const key in SafeLocation) {
        if (Object.prototype.hasOwnProperty.call(SafeLocation, key)) {
            if (SafeLocation[key as keyof typeof SafeLocation] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SafeLocationFromJSON(json: any): SafeLocation {
    return SafeLocationFromJSONTyped(json, false);
}

export function SafeLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SafeLocation {
    return json as SafeLocation;
}

export function SafeLocationToJSON(value?: SafeLocation | null): any {
    return value as any;
}

export function SafeLocationToJSONTyped(value: any, ignoreDiscriminator: boolean): SafeLocation {
    return value as SafeLocation;
}

